package com.ervasstudio.tracoemovimento.components.custumcomponents.layout

import androidx.compose.runtime.Composable
import com.ervasstudio.tracoemovimento.components.custumcomponents.BotaoDesfalecido
import com.ervasstudio.tracoemovimento.components.custumcomponents.BotaoEstilizado
import com.ervasstudio.tracoemovimento.model.Paginas

@Composable
fun MenuCentral(
    currentPath: String,
    onClick: (rota: String) -> Unit,
    isLogdeIn: Boolean = false,
    isMobile: Boolean = false,
) {
    // 1. Definimos os estados baseados na rota atual
    val isMeusCursos = currentPath.contains("cursos/meuscursos/")
    val isAuth = currentPath.contains("login") || currentPath.contains("signup")

    if (isLogdeIn) {

        // 2. Renderizamos o botão CURSOS
        if (!isMeusCursos && !isAuth) {
            BotaoEstilizado(nome = Paginas.CURSOS.name, isMobile = isMobile,)
        } else {
            BotaoDesfalecido(
                nome = Paginas.CURSOS.name,
                rota = Paginas.CURSOS.rota,
                onClick = { onClick(Paginas.CURSOS.rota) },
                isMobile = isMobile
            )
        }

        // 3. Renderizamos o botão MEUS CURSOS
        if (isMeusCursos) {
            BotaoEstilizado(nome = Paginas.`MEUS CURSOS`.name, isMobile = isMobile,)
        } else {
            BotaoDesfalecido(
                nome = Paginas.`MEUS CURSOS`.name,
                rota = Paginas.`MEUS CURSOS`.rota,
                onClick = { onClick(Paginas.`MEUS CURSOS`.rota) },
                isMobile = isMobile
            )
        }

    }else{

        if (!isMeusCursos && !isAuth) {
            BotaoEstilizado(nome = Paginas.CURSOS.name, isMobile = isMobile,)
        } else {
            BotaoDesfalecido(
                nome = Paginas.CURSOS.name,
                rota = Paginas.CURSOS.rota,
                onClick = { onClick(Paginas.CURSOS.rota) },
                isMobile = isMobile
            )
        }

    }

}

